<nb-layout class="main-container main-container-fixed">

  <!-- HEADER -->
  <nb-layout-header fixed>
    <div class="header-container">
      <button nbButton 
              size="small" 
              status="primary" 
              class="sidebar-toggle-btn"
              (click)="toggleSidebar()"
              aria-label="Toggle Menu">
        ☰
      </button>
      <app-user-header-component></app-user-header-component>
    </div>
  </nb-layout-header>

  <!-- SIDEBAR -->
  <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
    <nb-menu [items]="filteredMenu"></nb-menu>
  </nb-sidebar>

  <!-- MAIN CONTENT -->
  <nb-layout-column class="custom-wrapper columns">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </nb-layout-column>



</nb-layout>